import { createReducer, on } from '@ngrx/store';
import { type ShopCartIconSettingsType } from '@common/types/shop-cart-icon-settings.type';
import {
    loadCartIcon,
    loadCartIconSuccess,
    loadCartIconFailure,
    saveCartIcon,
    saveCartIconSuccess,
    saveCartIconFailure,
    setChangedState,
} from './shop-cart-icon.actions';
import type { WebLegacyWidgetEntity } from '@web/types';

export interface CartIconState {
    data: ShopCartIconSettingsType | null;
    isCartEnabled: boolean;
    cachedCartWidgetIndex: number;
    cachedCartWidget: WebLegacyWidgetEntity;
    loading: boolean;
    isChanged: boolean;
    error: any;
}

export const initialState: CartIconState = {
    data: null,
    isCartEnabled: false,
    cachedCartWidgetIndex: null,
    cachedCartWidget: null,
    loading: false,
    isChanged: false,
    error: null,
};

export const shopCartIconReducer = createReducer(
    initialState,
    on(loadCartIcon, (state) => ({ ...state, loading: true, error: null })),
    on(loadCartIconSuccess, (state, { data, isCartEnabled }) => ({
        ...state,
        data,
        isCartEnabled,
        loading: false,
        error: null,
    })),
    on(loadCartIconFailure, (state, { error }) => ({ ...state, loading: false, error })),

    on(saveCartIcon, (state) => ({ ...state, loading: true, error: null })),
    on(saveCartIconSuccess, (state, { data }) => ({
        ...state,
        data,
        loading: false,
        error: null,
    })),
    on(saveCartIconFailure, (state, { error }) => ({ ...state, loading: false, error })),
    on(setChangedState, (state, { isChanged }) => ({
        ...state,
        isChanged,
    }))
);
